import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { AsyncPipe } from '@angular/common';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [AsyncPipe, RouterModule, NgbDropdownModule]
})
export class HeaderComponent {
  userEmail$: Observable<string | null>;
  isLoggedIn$: Observable<boolean | null>; 

  constructor(private auth: AuthService, 
                private router: Router) {

    this.userEmail$ = this.auth.user$.pipe(
        map((u) => u?.email ?? null)
    );

    this.isLoggedIn$ = this.auth.user$.pipe(
        map((u) => u?.email ? true : false )
    )
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }
}
